import formDisplay from './formDisplay'
import recursiveReducer from './recursiveReducer'
import userInfo from "./userInfo"
import conditionalRendering from "./conditionalRendering"
import otpReducer from './otpReducer'
import configurationReducer from './configurationReducer';
import uploadDocumentReducer from './uploadDocumentReducer'
import consentReducer from './consentReducer'
import dashboardReducer from './dashboardReducer'
import stepperReducer from './stepperReducer'
import commentsReducer from './commentsReducer'
import activityListReducer from './activityListReducer'
import dashBoardDetailReducer from './dashBoardDetailReducer'
import requestedDocReducer from './requestedDocReducer'
import popupReducer from './popupReducer'
import vkycReducer from './vkycReducer'
import fieldRecursiveReducer from './fieldRecursiveReducer'
import requestedSupportingDocs from './requestedSupportingDocs'
import downloadRepo from './downloadRepoReducer'
import urlEncryption from './urlEncryption'
import loggedInUserInfo from './loggedInUserInfo'
import staticData from './staticData'
import paymentReducer from './paymentReducer'
import guardianReducer from './guardianReducer'
import usersReducer from './usersReducer'

const rootReducer = {
    formData: formDisplay,
    guardianRecursive: guardianReducer,
    recursive: recursiveReducer,
    userInfo: userInfo,
    conditionalRendering: conditionalRendering,
    otpReducer: otpReducer,
    configurationReducer: configurationReducer,
    uploadDocumentReducer: uploadDocumentReducer,
    consentReducer: consentReducer,
    dashboardReducer: dashboardReducer,
    stepperReducer: stepperReducer,
    commentsReducer: commentsReducer,
    activityListReducer: activityListReducer,
    dashboardDetailReducer: dashBoardDetailReducer,
    requestedDocReducer: requestedDocReducer,
    popupReducer: popupReducer,
    vkycReducer: vkycReducer,
    fieldRecursiveReducer: fieldRecursiveReducer,
    requestedSupportingDocs: requestedSupportingDocs,
    downloadRepo: downloadRepo,
    urlEncryption: urlEncryption,
    loggedInUserInfo: loggedInUserInfo,
    staticData: staticData,
    paymentReducer: paymentReducer,
    usersReducer: usersReducer
}

export default rootReducer